document.addEventListener("alpine:init", () => {
    Alpine.data("WatchspotSellerRegister", (customerId) => ({
        loading: false,
        loadingPre: false,
        errors: {},
        shopifyCustomerId: customerId,
        customerData: {},
        rgCnhFrontPreview: "",
        rgCnhVersePreview: "",
        isPreValidate: false,
        isValidate: false,
        continueForm: false,
        register: {
            fullName: "",
            cpf: "",
            rg: "",
            phoneNumber: "",
            email: "",
            birthdate: "",
            address: {
                cep: "",
                street: "",
                number: "",
                city: "",
                state: "",
                district: "",
                complement: "",
            },
            images: {
                rgCnhFront: "",
                rgCnhVerse: "",
            },
            faceMatchId: "",
            bank: {
                bankId: 0,
                bank: "",
                agency: "",
                account: "",
                digit: "",
                pix: "",
                cpf: ""
            },
        },
        formatPayload(payload) {
            const formatted = JSON.parse(JSON.stringify(payload));
            formatted.cpf = payload.cpf.replace(/\D/g, "");
            formatted.birthdate = formatBirthDate(payload.birthdate);
            return formatted;
        },
        async getCustomer() {
            this.loading = true;
            try {
                const resp = await fetch(
                    `https://voudeclick-watchspot-shopify.azurewebsites.net/Customer?shopifyCustomerId=${this.shopifyCustomerId}`,
                );
                if (!resp.ok) throw new Error("Erro");
                const data = await resp.json();
                this.customerData = data;
                this.register.cpf = data.cpf;
                this.register.fullName = data.name;
                this.register.birthdate = formatDate(data.birthdate);
            } catch (e) {
                console.log("Customer não encontrado");
            } finally {
                console.log("Busca de customer finalizada");
                this.loading = false;
            }
        },
        async preValidate() {
            const sendPayload = this.formatPayload(this.register);
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(sendPayload),
            };
            const endpoint =
                "https://voudeclick-watchspot-shopify.azurewebsites.net/seller/prevalidation";
            const response = await fetch(endpoint, requestOptions);
            const responseJson = await response.json();
            return responseJson;
        },
        async validate() {
            const sendPayload = this.formatPayload(this.register);
            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(sendPayload),
            };
            const endpoint =
                "https://voudeclick-watchspot-shopify.azurewebsites.net/seller/validation";
            const response = await fetch(endpoint, requestOptions);
            const responseJson = await response.json();
            return responseJson;
        },
        changeBank(element) {
            const val = element.target.value;
            if (val === "") {
                this.register.bank.bankId = 0;
                this.register.bank.bank = "";
            }
            const splitValue = val.split("-");
            const id = Number(splitValue[0]);
            this.register.bank.bankId = id;
            this.register.bank.bank = val;
        },
        handleChangeImage(element) {
            const previewName = element.attributes["data-preview"].value;
            const file = element.files?.[0];
            const name = element.name;
            if (file) {
                const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
                const allowedExtensions = [".png", ".jpg", ".jpeg"];
                const fileExtension =
                    "." + file.name.split(".").pop().toLowerCase();

                const isValidType =
                    allowedTypes.includes(file.type) ||
                    allowedExtensions.includes(fileExtension);
                if (!isValidType) {
                    this.$store.toast.open(
                        "warning",
                        "Por favor selecione um formato de imagem válido!",
                    );
                    return false;
                }
                const previewURL = URL.createObjectURL(file);
                this[previewName] = [previewURL];
                const reader = new FileReader();
                reader.onloadend = () => {
                    const sendBase64 = String(reader.result).split(",")[1];
                    this.register.images[name] = sendBase64;
                };
                reader.readAsDataURL(file);
            }
        },
        async getCep() {
            if (
                this.register.address.cep.trim() &&
                this.register.address.cep.replace(/\D/g, "").length < 8
            )
                return;
            try {
                const resp = await fetch(
                    `https://viacep.com.br/ws/${this.register.address.cep}/json/`,
                );
                if (!resp.ok) throw new Error("Erro");
                const data = await resp.json();
                this.register.address.street = data.logradouro;
                this.register.address.city = data.localidade;
                this.register.address.state = data.uf;
                this.register.address.district = data.bairro;
            } catch (e) {
                console.log("CEP inválido");
            } finally {
                console.log("Busca endereço finalizada");
            }
        },
        async handleNext() {
            if (this.isPreValidate) {
                this.$store.selfie.show = true;
                this.continueForm = true;
                return;
            }
            this.errors = {};
            if (!this.register.fullName.trim())
                this.errors.fullName = "Nome é obrigatório";
            if (!this.register.birthdate.trim())
                this.errors.birthdate = "Data de Nascimento é obrigatória";
            if (
                this.register.birthdate.trim() &&
                this.register.birthdate.replace(/\D/g, "").length < 8
            )
                this.errors.birthdate = "Data de Nascimento inválida";
            if (!this.register.address.cep.trim())
                this.errors.cep = "CEP é obrigatório";
            if (
                this.register.address.cep.trim() &&
                this.register.address.cep.replace(/\D/g, "").length < 8
            )
                this.errors.cep = "CEP inválido";
            if (!this.register.address.street.trim())
                this.errors.street = "Endereço é obrigatório";
            if (!this.register.address.number.trim())
                this.errors.number = "Número é obrigatório";
            if (!this.register.address.city.trim())
                this.errors.city = "Cidade é obrigatória";
            if (!this.register.address.state.trim())
                this.errors.state = "Estado é obrigatório";
            if (!this.register.address.district.trim())
                this.errors.district = "Bairro é obrigatório";
            if (!this.register.bank.bank.trim())
                this.errors.bank = "Banco é obrigatório";
            if (!this.register.bank.agency.trim())
                this.errors.agency = "Agência é obrigatória";
            if (!this.register.bank.account.trim())
                this.errors.account = "Conta é obrigatória";
            if (!this.register.bank.cpf.trim())
                this.errors.bankCpf = "CPF da conta é obrigatório";

            if (Object.keys(this.errors).length > 0) return;

            if (
                !this.register.images.rgCnhFront.trim() ||
                !this.register.images.rgCnhVerse.trim()
            ) {
                this.$store.toast.open(
                    "warning",
                    "Você precisa nos enviar os documentos antes de continuar",
                );
                return;
            }

            this.loadingPre = true;

            const checkPreValidate = await this.preValidate();
            if (!checkPreValidate.identityValidated) {
                let message = "";
                let fieldsValidate = [];
                if (checkPreValidate.message) {
                    message = checkPreValidate.message;
                }
                if (
                    checkPreValidate.fieldsValue &&
                    checkPreValidate.fieldsValue.length > 0
                ) {
                    fieldsValidate = checkPreValidate.fieldsValue;
                }
                let returnMessage = "Por favor revise seus dados: \n";
                if (message !== "") {
                    const lines = message
                        .split("!")
                        .map((line) => line.trim())
                        .filter((line) => line.length > 0);
                    lines.forEach((line, idx) => {
                        const currentField = line
                            .replace("no documento enviado não confere", "")
                            .trim();
                        const fieldName = getFieldName(currentField);
                        if (fieldName !== currentField) {
                            this.errors[fieldName] = line;
                        }
                        returnMessage += `- ${line} \n`;
                    });
                }

                if (fieldsValidate.length > 0) {
                    fieldsValidate.forEach((item, idx) => {
                        const fieldName = getFieldName(item.field);
                        if (fieldName !== item.field) {
                            this.errors[fieldName] = item.value;
                        }
                        returnMessage += `- ${item.value} \n`;
                    });
                }

                this.$store.toast.open("error", returnMessage);
                this.loadingPre = false;
                return;
            }

            //open selfie modal
            this.continueForm = true;
            this.isPreValidate = true;
            this.$store.selfie.show = true;
            this.loadingPre = false;
        },
        async sendSeller() {
            this.loading = true;
            const sendPayload = this.formatPayload(this.register);
            try {
                const resp = await fetch(
                    `https://voudeclick-watchspot-shopify.azurewebsites.net/seller/create?shopifyCustomerId=${this.shopifyCustomerId}`,
                    {
                        method: "POST",
                        headers: {
                            Accept: "*/*",
                            "Content-Type": "application/json-patch+json",
                        },
                        body: JSON.stringify(sendPayload),
                    },
                );
                const data = await resp.json();
                if (!resp.ok) throw new Error(data?.message);
                this.$store.toast.open(
                    "success",
                    "Cadastro enviado com sucesso!",
                );
                setTimeout(() => {
                    window.location.href = "/pages/seller-aguardando-aprovacao";
                }, 2000);
            } catch (e) {
                this.$store.toast.open(
                    "error",
                    `Não foi possível concluir sua solicitação no momento, ${e.message}`,
                );
            } finally {
                this.loading = false;
            }
        },
        async handleSave() {
            const currentSelfieId = this.$store.selfie.selfieId;
            if (currentSelfieId === "") return;

            this.register.faceMatchId = currentSelfieId;
            // const sendPayload = this.formatPayload(this.register);

            this.loadingPre = true;

            const checkValidate = await this.validate();

            if (!checkValidate.identityValidated) {
                let returnMessage = "Por favor revise seus dados: \n";
                if (checkValidate.message) {
                    returnMessage += checkValidate.message;
                }

                this.$store.toast.open("error", returnMessage);
                this.loadingPre = false;
                this.$store.selfie.selfieId = "";
                this.register.faceMatchId = "";
                this.continueForm = false;
                return;
            }

            this.loadingPre = false;
            this.sendSeller();
        },
        init() {
            this.getCustomer();
        },
    }));
});
